export enum NotesListFilterKeys {
  selectedWarehouseId = 'selectedWarehouseId',
  deadlineDateFrom = 'deadlineDateFrom',
  deadlineDateTo = 'deadlineDateTo',
  creationDateFrom = 'creationDateFrom',
  creationDateTo = 'creationDateTo',
  noteType = 'noteType',
  assignedUsers = 'assignedUsers',
}
